import { render, staticRenderFns } from "./RedeemProduk.vue?vue&type=template&id=62aa1b2f&scoped=true"
import script from "./RedeemProduk.vue?vue&type=script&lang=js"
export * from "./RedeemProduk.vue?vue&type=script&lang=js"
import style0 from "./RedeemProduk.vue?vue&type=style&index=0&id=62aa1b2f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "62aa1b2f",
  null
  
)

export default component.exports